module.exports = __webpack_public_path__ + "static/media/01n.6c014a7b.png";